import { createContext, PropsWithChildren, ReactElement, useContext, useMemo } from 'react'
import { CatalogTitle, getFirstTitleRating } from '@/services/ContentCatalog'
import { ProjectMeta } from '@/services/ProjectsService'
import { Maybe } from '@/utils/types'

export type ProjectMetaContext = {
  catalogTitle?: Maybe<CatalogTitle>
  project?: Maybe<ProjectMeta>
}

export interface ProjectMetaProviderProps extends PropsWithChildren<unknown> {
  catalogTitle?: Maybe<CatalogTitle>
  project?: Maybe<ProjectMeta>
}

export type ProjectMetaProvider = (props: ProjectMetaProviderProps) => ReactElement<ProjectMetaContext>

export const ProjectMetaContext = createContext<ProjectMetaContext>({ catalogTitle: null, project: null })

export const ProjectMetaProvider = ({
  catalogTitle,
  children,
  project,
}: ProjectMetaProviderProps): ReactElement<ProjectMetaContext> => {
  const value = useMemo(() => {
    return { project, catalogTitle }
  }, [project, catalogTitle])
  return <ProjectMetaContext.Provider value={value}>{children}</ProjectMetaContext.Provider>
}

export const useProjectMeta = (): ProjectMeta => {
  const projectContext = useContext(ProjectMetaContext)

  if (!projectContext.project) {
    return {} as ProjectMeta
  }

  const { project } = projectContext

  const contentRating = getFirstTitleRating(project?.title)

  return {
    ...projectContext.project,
    contentRating,
  }
}
